import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input , Row, Col, Form, Label, FormGroup} from 'reactstrap';
import HubspotContactForm from './HubspotForm';

const EmailCollectorModal = (props) => {

  const {
    isModalOpen = false,
    onClose
  } = props

  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);


  useEffect(() => {
    setOpen(isModalOpen)
  }, [isModalOpen])

  const handleClose = () => {
    setOpen(false);
    if(!onClose || typeof(onClose) !== 'function') return;
    onClose();
  }


  return (
  <div>
      <Modal
        id="modal-email" size='lg'
        isOpen={open} toggle={toggle} {...props}
        fullscreen="sm" centered onClosed={onClose}
        className='modal-email-calculator'
        style={{maxWidth: 1180}}
      >
        <ModalHeader toggle={toggle}></ModalHeader>
        <ModalBody>
          <h1 className='blue-text'>Certified California Child Support Calculator</h1>
          <p className='body-copy mt-32'>
          We’re looking forward to bringing you a comprehensive calculator that you can use to start or amend you child support agreements.
          </p>
          <p className='body-copy mt-24'>
          
          Want to stay informed about our official calculator releases? Subscribe to our mailing list below.</p>
        
        <HubspotContactForm></HubspotContactForm>

    <p className='body-copy mt-24'>If you have any additional questions about child support, feel free to check out our resources.</p>
  

    <a href='https://hellodivorce.com/support-calculators/child-support-resources' className='cta blue-text mt-24'>
      Hello Divorce Child Support Resources
    </a>
  </ModalBody>







        <ModalFooter>
        <Button className='btn-line cta blue-text' onClick={handleClose}>
          Done
        </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default EmailCollectorModal;

